import { Flex } from 'components/base/layout-components';

export const IssueStateTooltip = ({ state, count }) => {
  return (
    <Flex padding='x-small'>
      We identified&nbsp;
      <b>
        {count} {state}&nbsp;
      </b>{' '}
      states across Jira and have combined them
    </Flex>
  );
};
